// import Dispatch from "pages/Inventory/Dispatch/Dispatch";
// import DispatchViewDetails from "pages/Inventory/Dispatch/DispatchViewDetails";

// import InventoryItemRequestStockAllocationForm from "pages/Inventory/ItemRequest/Form";
// import InventoryItemRequest from 'pages/Inventory/ItemRequest/index';
// import ApprovalLog from "pages/Inventory/ItemRequest/ItemRequestListing/ApprovalLog/ApprovalLog";
// import ApprovalLogViewDetails from "pages/Inventory/ItemRequest/ItemRequestListing/ApprovalLog/ApprovalLogViewDetails";
// import PendingApproval from "pages/Inventory/ItemRequest/ItemRequestListing/PendingApproval/PendingApproval";
// import PendingApprovalViewDetails from "pages/Inventory/ItemRequest/ItemRequestListing/PendingApproval/PendingApprovalViewDetails";
// import StockAllocationLog from "pages/Inventory/ItemRequest/ItemRequestListing/StockAllocationLog/StockAllocationLog";
// import StockAllocationLogViewDetails from "pages/Inventory/ItemRequest/ItemRequestListing/StockAllocationLog/StockAllocationLogViewDetails";
// import Packing from "pages/Inventory/Packing/Packing";
// import PackingViewDetails from "pages/Inventory/Packing/PackingViewDetails";
// import InventoryPurchaseOrder from "pages/Inventory/PurchaseOrder/index";
// import GRNNestedViewDetails from "pages/Inventory/PurchaseOrder/PurchaseOrderListing/GRN/GRNNestedViewDetails";
// import GRNViewDetails from "pages/Inventory/PurchaseOrder/PurchaseOrderListing/GRN/GRNViewDetails";
// import ReceivedPONestedViewDetails from "pages/Inventory/PurchaseOrder/PurchaseOrderListing/ReceivedPO/ReceivedPONestedViewDetails";
// import ReceivedPOViewDetails from "pages/Inventory/PurchaseOrder/PurchaseOrderListing/ReceivedPO/ReceivedPOViewDetails";
import InventoryReorderLevel from "pages/Inventory/ReorderLevelOld/index";
import ReorderLevelForm from "pages/Inventory/ReorderLevelOld/ReorderLevelFrom";
// import HistoryViewDetails from "pages/Inventory/TransferRequest/TransferRequestListing/History/HistoryViewDetails";
// import TransferRequestViewDetails from "pages/Inventory/TransferRequest/TransferRequestListing/TransferRequest/TransferRequestViewDetails";
// import InventoryStockTransferRequest from "pages/Inventory/StockTransferRequest/index"
// import StockTransferApprovalLogViewDetails from "pages/Inventory/StockTransferRequest/StockTransferRequestListring/StockTransferApprovalLog/StockTransferApprovalLogViewDetails";
// import StockTransferPendingApprovalViewDetails from "pages/Inventory/StockTransferRequest/StockTransferRequestListring/StockTransferPendingApproval/StockTransferPendingApprovalViewDetails";
// import StockTransferStockAllocationLogViewDetails from "pages/Inventory/StockTransferRequest/StockTransferRequestListring/StockTransferStockAllocationLog/StockTransferStockAllocationLogViewDetails";
// import InventoryItemRequestStockTransferStockAllocationForm from "pages/Inventory/StockTransferRequest/Form";
// import CreateStockAllocation from "pages/Inventory/ItemRequest/ItemRequestListing/StockAllocationLog/CreateStockAllocation";
import { action_options, app_modules } from "helpers/apps_modules_list";
import InStockComponent from "pages/Inventory/Inventory/index";
import ItemDetailsView from "pages/Inventory/Inventory/List/ItemDetailsView";
import ReorderLevelList from "pages/Inventory/ReorderLevel/List";
import InStockList from "pages/Inventory/Inventory/List";
import ProductStockInfo from "pages/Inventory/Inventory/List/StockOverview/ProductStockInfo";
// import ReorderLevelList from 'pages/Inventory/ReorderLevel/List';

const InventoryRoutes: any = [
  {
    path: "/inventory",
    name: "In Stock",
    component: <InStockList />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.in_stock,
      action: action_options?.view,
    },
  },
  // {
  //   path: "/inventory-purchase-order",
  //   name: "Inventory Purchase Order",
  //   component: <InventoryPurchaseOrder />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.purchase_order, action: action_options?.view }
  // },

  // {
  //   path: "/inventory-purchase-order-received-po-view",
  //   name: "Inventory Purchase Order Received Po View",
  //   component: <ReceivedPOViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.purchase_order, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-purchase-order-received-po-nested-view",
  //   name: "Inventory Purchase Order Received Po nested View",
  //   component: <ReceivedPONestedViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.purchase_order, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-purchase-order-grn-view",
  //   name: "Inventory Purchase Order GRN View",
  //   component: <GRNViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.purchase_order, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-purchase-order-grn-nested-view",
  //   name: "Inventory Purchase Order GRN nested View",
  //   component: <GRNNestedViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.purchase_order, action: action_options?.view }
  // },

  //stock Transfer Request Routes
  // {
  //   path: "/inventory-transfer-request",
  //   name: "Inventory transfer request",
  //   component: <InventoryStockTransferRequest />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.stock_transfer_request, action: action_options?.view }
  // },
  // {
  //   path: "/stock-transfer-approval-log-view-details",
  //   name: "Stock Transfer ApprovalLog ViewDetails",
  //   component: <StockTransferApprovalLogViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.stock_transfer_request, action: action_options?.view }
  // },
  // {
  //   path: "/stock-transfer-pending-approval-view-details",
  //   name: "Stock Transfer PendingApproval ViewDetails",
  //   component: <StockTransferPendingApprovalViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.stock_transfer_request, action: action_options?.view }
  // },
  // {
  //   path: "/stock-transfer-stock-allocation-log-view-details/",
  //   name: "Stock Transfer Stock Allocation Log View Details",
  //   component: <StockTransferStockAllocationLogViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.stock_transfer_request, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-transfer-request-view",
  //   name: "Inventory transfer request view",
  //   component: <TransferRequestViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.stock_transfer_request, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-transfer-request-history-view",
  //   name: "Inventory transfer request history view",
  //   component: <HistoryViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.stock_transfer_request, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-itemRequest-stockTransfer-stockAllocation-form",
  //   name: "InventoryItemRequestStockTransferStockAllocationForm",
  //   component: <InventoryItemRequestStockTransferStockAllocationForm />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.stock_transfer_request, action: action_options?.create }
  // },
  // Item Request routes
  // {
  //   path: "/inventory-item-request",
  //   name: "Inventory item request",
  //   component: <InventoryItemRequest />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.item_request, action: action_options?.create }
  // },
  // {
  //   path: "/inventory-item-request-create-stock-allocation",
  //   name: "Inventory item request create stock transfer",
  //   component: <CreateStockAllocation />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.item_request, action: action_options?.create }
  // },
  // {
  //   path: "/inventory-item-request-approvallog-view",
  //   name: "Inventory item request approvallog view",
  //   component: <ApprovalLog />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.item_request, action: action_options?.create }
  // },
  // {
  //   path: "/inventory-item-request-approvallog-view-deatils/:id",
  //   name: "Inventory item request approvallog view details",
  //   component: <ApprovalLogViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.item_request, action: action_options?.view }
  // },

  // {
  //   path: "/inventory-item-request-pendinglog-view",
  //   name: "Inventory item request pendinglog view",
  //   component: <PendingApproval />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.item_request, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-item-request-pendinglog-view-deatils/:id",
  //   name: "Inventory item request pendinglog view details",
  //   component: <PendingApprovalViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.item_request, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-item-request-stock-allocationlog-view",
  //   name: "Inventory Item Request Stock Allocationlog View",
  //   component: <StockAllocationLog />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.item_request, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-item-request-stock-allocationlog-view-deatils",
  //   name: "Inventory item request approvallog view details",
  //   component: <StockAllocationLogViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.item_request, action: action_options?.view }
  // },

  //packing routes
  // {
  //   path: "/inventory-packing",
  //   name: "Inventory Packing",
  //   component: <Packing />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.packing, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-packing-view",
  //   name: "Inventory Packing view",
  //   component: <PackingViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.packing, action: action_options?.view }
  // },
  //dispatch routes
  // {
  //   path: "/inventory-dispatch",
  //   name: "Inventory Dispatch",
  //   component: <Dispatch />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.dispatch, action: action_options?.view }
  // },
  // {
  //   path: "/inventory-dispatch-view",
  //   name: "Inventory Dispatch view",
  //   component: <DispatchViewDetails />,
  //   permissions: { app_name: app_modules?.inventory?.app_name, module_name: app_modules?.inventory?.modules?.dispatch, action: action_options?.view }
  // },
  {
    path: "/inventory-reorder-level",
    name: "Inventory Reorder Level",
    component: <ReorderLevelList />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.reorder_level,
      action: action_options?.view,
    },
  },
  {
    path: "/inventory-create-reorder-level",
    name: "Inventory Create Reorder Level",
    component: <ReorderLevelForm />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.reorder_level,
      action: action_options?.create,
    },
  },
  {
    path: "/inventory-item-details/:id/:warehouseId",
    name: "Inventory Item Details",
    component: <ProductStockInfo />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.in_stock,
      action: action_options?.view,
    },
  },
];

export default InventoryRoutes;
